import React, { Component } from 'react';
import ChevronLeft from 'material-ui/svg-icons/navigation/chevron-left';
import ChevronRight from 'material-ui/svg-icons/navigation/chevron-right';
import IconButton from 'material-ui/IconButton';

const styles = {
  footerContent: {
    float: 'right'
  },
  footerText: {
    float: 'right',
    paddingTop: '16px',
    height: '16px'
  }
};

class PaginationFooter extends Component {
  render() {
    let { offset, total, limit, activeConferencesMode } = this.props;
    return (
      <div style={styles.footerContent}>
        <IconButton disabled={offset === 0}
          onClick={() => this.props.paginationHanlder(offset, limit, total, 'bwd', activeConferencesMode)}>
          <ChevronLeft/>
        </IconButton>
        <IconButton disabled={offset + limit >= total}
          onClick={() => this.props.paginationHanlder(offset, limit, total, 'fwd', activeConferencesMode)}>
          <ChevronRight/>
        </IconButton>
        <div style={styles.footerText}>
          Total: {total}
        </div>
      </div>
    );
  }
}

export default PaginationFooter;



// WEBPACK FOOTER //
// ./src/components/PaginationFooter.js